import {Box, CircularProgress} from '@mui/material'
import {ReactNode, Suspense} from 'react'

interface Props {
  children?: ReactNode
}

export const PageSuspenseFallback = ({children}: Props) => {
  return (
    <Suspense
      fallback={
        <Box sx={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <CircularProgress />
        </Box>
      }
    >
      {children}
    </Suspense>
  )
}
